import type { ReactNode } from "react";
import { useLocale } from "./LocaleProvider";

type LocalizedTextProps = {
  id: string;
  values?: Record<string, string | number>;
};

export function LocalizedText({ id, values }: LocalizedTextProps) {
  const { t } = useLocale();
  const template = t(id);
  return <>{interpolate(template, values)}</>;
}

type LocalizedRichTextProps = {
  id: string;
  values?: Record<string, ReactNode>;
};

export function LocalizedRichText({ id, values = {} }: LocalizedRichTextProps) {
  const { t } = useLocale();
  const template = t(id);
  const parts = template.split(/(\{[A-Za-z0-9_]+\})/g);

  return (
    <>
      {parts.map((part) => {
        const match = part.match(/^\{([A-Za-z0-9_]+)\}$/);
        if (!match) return part;

        const replacement = values[match[1]];
        return replacement === undefined ? part : replacement;
      })}
    </>
  );
}

function interpolate(
  template: string,
  values?: Record<string, string | number>,
) {
  if (!values) return template;
  return Object.entries(values).reduce(
    (result, [name, value]) => result.replaceAll(`{${name}}`, String(value)),
    template,
  );
}
